import axios from 'axios'
import { REACT_APP_API_ABM_FW } from '../../config'

export async function getCarLots(queryString) {
    try {
        const response = await axios(REACT_APP_API_ABM_FW + '/abms/car_lot/product_owners' + queryString)
        return response?.data?.data || []
    } catch (e) {
        console.error('Error al obtener concesionarios', e)
        return []
    }
}
